export default "__VITE_ASSET__DipOsc$M__"